import { DEFAULT_ROUTE_DETAILS_ICON } from '../../mockData';
import { IRouteDetailsDataBlobProps } from '../../../../../sp-types/routeDetailsType';
import { routeDetailsIcons } from '../../routeDetailsUtils';
import React from 'react';

export const RouteDetailsDataBlob: React.FC<IRouteDetailsDataBlobProps> = ({
  dataList,
  title,
  isAlert,
  icon: image,
}) => {
  return (
    <div className="bg-gray flex gap-2">
      <img className="h-6 w-6 " src={routeDetailsIcons[image] || DEFAULT_ROUTE_DETAILS_ICON} />
      <div className={`${isAlert ? 'bg-pink-100' : 'bg-gray-50'} space-y-2 rounded-md px-3 py-2`}>
        <p>{title}</p>
        <div className="flex gap-2 divide-x ">
          {dataList.map((item, index) => (
            <div key={index} className={`${index !== 0 && 'border-l border-gray-100 ps-2'}`}>
              <p className={` whitespace-nowrap ${!item.value && 'text-gray-450'}`}>{item.value || 'N/A'}</p>
              {item.title && <p className="text-gray-450 text-sm whitespace-nowrap">{item.title}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
